<div class="radio">
  <input
    type="radio"
    [name]="filterName()"
    [value]="value()"
    [(ngModel)]="checked"
    (ngModelChange)="propagateChange($event)"
    (blur)="onTouched()"
    [disabled]="isDisabled()"
    [id]="label() + value()" />
  <label class="radio-label" [for]="label() + value()"
    >{{ label() | translate }}
  </label>
</div>
